import {ForumOutlined} from "@mui/icons-material";
import CodeOutlined from "@mui/icons-material/CodeOutlined";
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import {lazy} from "react";
import type {Page, PageGroup} from "router/types";

const DocumentationPage = lazy(
  () => import("pages/developer-settings/documentation/DocumentationPage"),
);
const MessagesApiDocsPage = lazy(
  () => import("pages/developer-settings/documentation/docs/MessagesDocsPage"),
);

const developerSettingsRoute: Array<Page | PageGroup> = [
  {
    segment: "developer-settings",
    title: "Developers",
    Icon: CodeOutlined,
    children: [
      {
        segment: "documentation",
        title: "API Documentation",
        Icon: DescriptionOutlined,
        Component: DocumentationPage,
      },
      {
        segment: "messages",
        title: "Messages API",
        Icon: ForumOutlined,
        Component: MessagesApiDocsPage,
      },
    ],
  },
];

export default developerSettingsRoute;
